import { Modal, Row, Col, Badge } from "react-bootstrap";
import userimg from "assets/images/avatar.svg";
import star from "assets/images/star.svg";
import BioSection from "Dashboard/Dashboardpages/Bio";

const PilotDetailsModal = ({
    show,
    onHide,
    pilot = {},
    portfolio = {},
    baseS3Url,
}) => {
    const {
        images = [],
        youtube_url_1,
        youtube_url_2,
        youtube_url_3,
        drones = [],
    } = portfolio || {};

    console.log("portfolio", portfolio);
    const youtubeLinks = [youtube_url_1, youtube_url_2, youtube_url_3].filter(Boolean);

    console.log("youtubeLinks", youtubeLinks);
    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton className="px-4">
                <h4 className="fw-semibold mb-0">Pilot Profile</h4>
            </Modal.Header>

            <Modal.Body className="px-4 py-4">
                <Row className="g-4">

                    {/* LEFT PANEL */}
                    <Col lg={4}>
                        <div
                            className="h-100 p-4 text-center"
                            style={{
                                background: "#0f172a",
                                borderRadius: 16,
                                color: "#fff",
                            }}
                        >
                            <img
                                src={pilot?.avatar ? `${baseS3Url}${pilot.avatar}` : userimg}
                                alt="pilot"
                                style={{
                                    width: 140,
                                    height: 140,
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                    border: "4px solid rgba(255,255,255,0.2)",
                                }}
                            />

                            <h5 className="mt-3 mb-1">{pilot?.fullName}</h5>

                            <div className="d-flex justify-content-center align-items-center gap-2 mb-3">
                                <img src={star} width={14} alt="rating" />
                                <small>{Math.round(pilot?.avgRating || 0)} Rating</small>
                            </div>

                            <BioSection bio={pilot?.bio} color="white" />

                            <div className="mt-4 text-start">
                                <h6 className="fw-semibold mb-2">Specialization</h6>

                                <div className="d-flex gap-2 flex-wrap">
                                    {pilot?.specialisedId?.length ? (
                                        pilot.specialisedId.map(item => (
                                            <Badge
                                                key={item._id}
                                                bg="light"
                                                text="dark"
                                                className="px-3 py-2"
                                                style={{ borderRadius: 20 }}
                                            >
                                                {item.title}
                                            </Badge>
                                        ))
                                    ) : (
                                        <small className="text-muted">Not specified</small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* RIGHT PANEL */}
                    <Col lg={8}>

                        {/* PORTFOLIO */}
                        {images.length > 0 && (
                            <>
                                <h6 className="fw-semibold mb-3">Portfolio</h6>

                                <Row className="g-3">
                                    {images.map((img, index) => (
                                        <Col md={4} key={index}>
                                            <img
                                                src={`${baseS3Url}${img}`}
                                                alt="portfolio"
                                                className="w-100"
                                                style={{
                                                    height: 160,
                                                    objectFit: "cover",
                                                    borderRadius: 12,
                                                    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                                                }}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        )}

                        {/* VIDEOS */}
                        {youtubeLinks.length > 0 && (
                            <>
                                <h6 className="fw-semibold mt-5 mb-3">Videos</h6>

                                <Row className="g-3">
                                    {youtubeLinks.map((url, index) => (
                                        <Col md={6} key={index}>
                                            <div
                                                style={{
                                                    borderRadius: 12,
                                                    overflow: "hidden",
                                                    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                                                }}
                                            >
                                                <iframe
                                                    src={url.replace("shorts/", "embed/").split("?")[0]}
                                                    title={`video-${index}`}
                                                    width="100%"
                                                    height="220"
                                                    allowFullScreen
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        )}

                        {/* DRONES */}
                        {drones.length > 0 && (
                            <>
                                <h6 className="fw-semibold mt-5 mb-3">Drones</h6>

                                <Row className="g-3">
                                    {drones.map(drone => (
                                        <Col md={4} key={drone.id}>
                                            <div
                                                className="p-3 h-100"
                                                style={{
                                                    borderRadius: 14,
                                                    background: "#fff",
                                                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                                                }}
                                            >
                                                <img
                                                    src={drone.images?.[0]}
                                                    alt={drone.model}
                                                    className="w-100 mb-2"
                                                    style={{
                                                        height: 140,
                                                        objectFit: "contain",
                                                    }}
                                                />
                                                <p className="fw-semibold mb-0">{drone.make}</p>
                                                <small className="text-muted">{drone.model}</small>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </>
                        )}

                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default PilotDetailsModal;
